<template>
<div>
  123456
</div>
</template>

<script>
export default {
  name: "test"
}
</script>

<style scoped>

</style>
